import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlayerApiService } from '../../services/player-api.service';
import { PlayerDataService } from '../../services/player-data.service';
import {UtilsService} from '../../services/utils.service'
@Component({
  selector: 'finance-decisions',
  standalone: true,
  imports: [
     CommonModule,   // ✅ Needed for built-in pipes like 'number', 'date', 'currency', etc.
    FormsModule
  ],
  templateUrl: './finance-decisions.component.html',
  styleUrl: './finance-decisions.component.css'
})
export class FinanceDecisionsComponent implements OnInit, OnDestroy{
  FID: any;
  RO: any;
  
  LT_borrowInWords = '';
  ST_borrowInWords = '';
  LT_repayInWords = '';
  I_shareInWords = '';
  Bb_shareInWords = '';
DividendInWords = '';
ARselectvals : number[] = [];
APselectvals : number[] = [];
selectedAP: number | null = null;
selectedAR: number | null = null;

  constructor(private api: PlayerApiService, private playerData: PlayerDataService, private utils: UtilsService) {}

  ngOnInit() {
     const user = JSON.parse(localStorage.getItem('user') || '{}');
  const playerId = user.userId;
  
console.log(playerId);

    const cached = this.playerData.getPageDecisionData('finance');
    console.log("on init")
       this.FID = cached;
      
     const roCached = this.playerData.getPageDecisionData('readonly');
    this.RO = roCached;
    console.log(this.RO);
    this.APselectvals = JSON.parse(this.RO.APARselectarr);
    this.ARselectvals = JSON.parse(this.RO.APARselectarr);
    if (this.FID.AP > 0){
      this.selectedAP = this.FID.AP;
    }
    if (this.FID.AR > 0){
      this.selectedAR = this.FID.AR;
    }
    
  }

  onAPChange(){
    console.log("AP selected "+this.selectedAP);

    this.FID.AP = this.selectedAP;
  }
  onARChange(){
    console.log("AR selected "+this.selectedAR);

    this.FID.AR = this.selectedAR;
  }
  onInputChange() {
    this.playerData.setPageDecisionData('finance', this.FID);
  }

  toggleCheckbox(row: any, col: string, event: any) {
    row[col] = event.target.checked;
    this.onInputChange();
  }

  ngOnDestroy() {
    this.playerData.setPageDecisionData('finance', this.FID);
  }
  CTW_LT_borrow() {
    this.LT_borrowInWords = this.utils.numberToWords(this.FID.LT_borrow);
  }
   CTW_ST_borrow() {
    this.ST_borrowInWords = this.utils.numberToWords(this.FID.ST_borrow);
  }
   CTW_Dividend() {
    this.DividendInWords = this.utils.numberToWords(this.FID.Dividend);
  }
   CTW_Bb_share() {
    this.Bb_shareInWords = this.utils.numberToWords(this.FID.Bb_share);
  } 
  CTW_LT_repay() {
    this.LT_repayInWords = this.utils.numberToWords(this.FID.LT_repay);
  } 
  CTW_I_share() {
    this.I_shareInWords = this.utils.numberToWords(this.FID.I_share);
  }

}


